var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step2-container" },
    [
      _c("div", { staticClass: "main-content-container no-scrollbar" }, [
        _c(
          "div",
          {
            staticClass: "content-header",
            class: [_vm.selectedAddonProducts.length > 0 ? "cart" : ""],
            attrs: { id: "jump1" }
          },
          [
            _c("img", {
              staticClass: "starburst lazyload",
              attrs: {
                alt: "start here",
                "data-src":
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/start_here.svg?v=1732206158"
              }
            }),
            _vm._v(" "),
            _vm._m(0)
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-container",
            class: [
              _vm.isSticking ? "sticky" : "",
              _vm.selectedAddonProducts.length > 0 ? "cart" : ""
            ],
            attrs: { id: "header-container" }
          },
          [
            _vm.currentOccassionImage
              ? _c("div", { staticClass: "placeholder-recommendations" }, [
                  _c("div", { staticClass: "buttons-container" }, [
                    _vm.bulkOpen
                      ? _c("div", { staticClass: "sort-block" }, [
                          _c(
                            "p",
                            {
                              staticClass: "close",
                              on: {
                                click: function() {
                                  _vm.bulkOpen = false
                                }
                              }
                            },
                            [_vm._v("X")]
                          ),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          _c("p", [_vm._v("Sort by high stock!")]),
                          _vm._v(" "),
                          _vm._m(2)
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "happybox-button white border",
                        class: _vm.totalCurrentFilters > 0 ? "selected" : "",
                        on: {
                          click: function($event) {
                            return _vm.showFilters()
                          }
                        }
                      },
                      [
                        _vm.totalCurrentFilters > 0
                          ? _c("img", {
                              staticClass: "purple",
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                              }
                            })
                          : _c("img", {
                              staticClass: "normal",
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"
                              }
                            }),
                        _vm._v(
                          "\n                        Filter Products\n                        "
                        ),
                        _vm.totalCurrentFilters > 0
                          ? _c("span", [
                              _vm._v(
                                "(" + _vm._s(_vm.totalCurrentFilters) + ")"
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "happybox-button white border",
                        on: {
                          click: function($event) {
                            return _vm.showSort()
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/Group_4412.png?v=1722267051"
                          }
                        }),
                        _vm._v("Sort Products")
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "leave-builder",
                      on: { click: _vm.leaveBuilder }
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value:
                                "Save your selections for 24 hours. Inventory subject to availability",
                              expression:
                                "'Save your selections for 24 hours. Inventory subject to availability'"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            "\n                        SAVE YOUR BOX\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value:
                              "Save your selections for 24 hours. Inventory subject to availability",
                            expression:
                              "'Save your selections for 24 hours. Inventory subject to availability'"
                          }
                        ],
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart.svg?v=1722005665",
                          alt: "save cart"
                        }
                      })
                    ]
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-container no-scrollbar" },
          [
            _c("div", { staticClass: "filters-container" }, [
              _c(
                "div",
                { staticClass: "sticky-filter" },
                [
                  _c("p", { staticClass: "title" }, [_vm._v("Product Type")]),
                  _vm._v(" "),
                  _c("CategoriesFilter", {
                    attrs: { categoriesArray: _vm.categories }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "products-wrapper",
                class: [_vm.selectedAddonProducts.length > 0 ? "big" : ""]
              },
              [
                !_vm.addonProducts || _vm.addonProducts.length == 0
                  ? _c(
                      "ul",
                      { staticClass: "products-container no-scrollbar" },
                      _vm._l(12, function(n) {
                        return _c(
                          "li",
                          { key: n },
                          _vm._l(12, function(n) {
                            return _c("AddonProductSkeleton", { key: n })
                          }),
                          1
                        )
                      }),
                      0
                    )
                  : _c(
                      "ul",
                      { staticClass: "products-container no-scrollbar" },
                      [
                        _vm.nonFilteredProducts.length > 0
                          ? _c("p", { staticClass: "other-gifts" }, [
                              _vm._v(_vm._s(_vm.breadcrumbText))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.sortedProducts, function(addonProduct) {
                          return _c(
                            "li",
                            { key: addonProduct.id },
                            [
                              _c("AddonProductNew", {
                                attrs: {
                                  product: addonProduct,
                                  cartProducts: _vm.selectedAddonProducts,
                                  maxCapacity: _vm.maxCapacity,
                                  currentCapacity: _vm.currentCapacity,
                                  boxQty: _vm.boxQty,
                                  productLimit: _vm.productLimit,
                                  addCopy: _vm.addCopy
                                },
                                on: {
                                  loadmodal: function($event) {
                                    return _vm.openModal($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _vm.nonFilteredProducts.length > 0
                          ? _c("p", { staticClass: "other-gifts" }, [
                              _vm._v("All Other Gifts")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.nonFilteredProducts, function(addonProduct) {
                          return _c(
                            "li",
                            { key: addonProduct.id },
                            [
                              _c("AddonProductNew", {
                                attrs: {
                                  product: addonProduct,
                                  cartProducts: _vm.selectedAddonProducts,
                                  maxCapacity: _vm.maxCapacity,
                                  currentCapacity: _vm.currentCapacity,
                                  boxQty: _vm.boxQty,
                                  productLimit: _vm.productLimit,
                                  addCopy: _vm.addCopy
                                },
                                on: {
                                  loadmodal: function($event) {
                                    return _vm.openModal($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
              ]
            ),
            _vm._v(" "),
            _c("SideCartNew", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isSticking,
                  expression: "isSticking"
                }
              ],
              attrs: { isSticking: _vm.isSticking, step: 1 },
              on: {
                changepage: function($event) {
                  return _vm.changePage($event)
                },
                openmodal: function($event) {
                  return _vm.openModal($event)
                },
                gostep: function($event) {
                  return _vm.goStep($event)
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("SideCartNew", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isSticking,
            expression: "!isSticking"
          }
        ],
        attrs: { isSticking: _vm.isSticking, step: 1 },
        on: {
          changepage: function($event) {
            return _vm.changePage($event)
          },
          openmodal: function($event) {
            return _vm.openModal($event)
          },
          gostep: function($event) {
            return _vm.goStep($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.showModal == true && _vm.currentSelectedAddon != null
        ? _c("AddonProductModal", {
            attrs: {
              selectedAddon: _vm.currentSelectedAddon,
              addonProducts: _vm.modalProducts,
              cartProducts: _vm.selectedAddonProducts,
              recommendedProducts: _vm.modalRecommendedProducts
            },
            on: {
              closemodal: function($event) {
                return _vm.closeModal()
              },
              changeselectedaddon: function($event) {
                return _vm.openModal($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filterIsShown
        ? _c("FiltersMobile", {
            attrs: {
              filteredPreAddons: _vm.filteredPreProducts,
              isSticking: _vm.isSticking,
              filteredAddons: _vm.sortedProducts
            },
            on: {
              closefilter: function($event) {
                return _vm.showFilters()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sortIsShown
        ? _c("SortMobile", {
            attrs: { isSticking: _vm.isSticking },
            on: {
              closefilter: function($event) {
                return _vm.showSort()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", { staticClass: "title" }, [_vm._v("Build a Gift Box")]),
      _vm._v(" "),
      _c("div", { staticClass: "sticky-image-container" }, [
        _c("p", { staticClass: "steps" }, [
          _vm._v(
            "\n                        STEP 1 OF 3:\n                        "
          ),
          _c("span", { staticClass: "dot current" }, [
            _c("span", { staticClass: "selected" })
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "dot" }, [_c("span")]),
          _vm._v(" "),
          _c("span", { staticClass: "dot" }, [_c("span")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Buying in bulk?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-t" }, [
      _c("div", { staticClass: "inner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sticky-image-container" }, [
      _c("p", { staticClass: "steps" }, [
        _vm._v("\n                        STEP 1 OF 3: "),
        _c("span", { staticClass: "legend" }, [_vm._v("Start adding gifts!")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot current" }, [
          _c("span", { staticClass: "selected" })
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "dot" }, [_c("span")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot" }, [_c("span")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }